import { AlertTriangle } from "lucide-react";
import { useEstudioMarketing } from "../EstudioMarketingLayout";

/**
 * Aviso de que los números de esta pantalla son de ejemplo, no de la cuenta
 * real. Va arriba de todo en Plan, Pieza, Insights y Estrategia — no en
 * Marca, que sí muestra datos reales.
 *
 * El propio banner lee `modoEjemplo` del contexto del layout en vez de
 * recibirlo como prop: así ninguna pantalla se puede olvidar de pasarlo, que
 * es la forma en que este tipo de cartel termina desapareciendo sin que
 * nadie lo note.
 */
export const BannerVistaEjemplo = () => {
  const { modoEjemplo } = useEstudioMarketing();
  if (!modoEjemplo) return null;

  return (
    <div className="flex items-center gap-2 rounded-xl bg-[#F7EBD5] py-3 px-4 text-[13px] font-medium text-[#8A5A08]">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>
        Vista de ejemplo — estos números no son de tu cuenta. Conectá tus fuentes para ver los
        tuyos.
      </span>
    </div>
  );
};

export default BannerVistaEjemplo;
